import React, { useCallback, useEffect, useRef, useState } from "react";
import { Row, Col, Typography, Button, Form, Modal } from "antd";

import moment from "moment";
import { useDispatch } from "react-redux";
import { getAddons, getProducts } from "services/locationCenter.services";
import {
  addLineItems,
  deleteLineItem,
  updateAppointmentDateTime,
  updateLineItem,
} from "services/booking.service";
import { push } from "connected-react-router";
import ChangeAppointmentModal from "components/ChangeAppointmentModal/ChangeAppointmentModal";

import BookingDetailRow from "./BookingDetailRow";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import ServiceAddonsModal from "./ServiceAddonsModal";
import { validateRestriction } from "services/restrictions.service";
import AuditLogModal, { Mode } from "components/ProfileDrawer/components/AuditLogModal";

const { Title, Text } = Typography;

export default function BookingDetails({
  booking = {},
  customer = {},
  disabled,
  isOrderCancelled,
  style,
  setShowEventDrawer,
  refreshCustomerRewards,
  rewards,
  isRewardsLoading,
  onClose,
  manageRewardsDisabled,
  isChartLoading
}) {
  const {
    serviceDate,
    lineItems,
    facilityId,
    operationTypeId,
    orderId,
    orderDuration,
    isInventorySubmitted,
    staffId,
  } = booking;

  const instructions = booking?.notes?.[0];
  const dispatch = useDispatch();

  const [showAuditLog, setShowAuditLog] = useState(false);

  const [showAddUpdateService, setShowAddUpdateService] = useState(false);
  const [showUpdateAppointmentDate, setShowUpdateAppointmentDate] =
    useState(false);

  const facilityServiceDate = moment(serviceDate);

  const isEditServiceModal = typeof showAddUpdateService === "object";

  const handleAddService = (values) => {
    // add new line item
    dispatch(addLineItems(orderId, [values])).then((res) => {
      if (res?.status === "success") {
        setShowAddUpdateService(false);
        setShowEventDrawer(false);
        refreshCustomerRewards();
      }
    });
    // update booking
  };

  const handleUpdateService = (lineItemId, values) => {
    // delete existing line item
    // add new line item
    // update booking
    if (!values.addOns) {
      values.addOns = [];
    }
    dispatch(updateLineItem(orderId, lineItemId, [values])).then((res) => {
      if (res?.status === "success") {
        setShowAddUpdateService(false);
        setShowEventDrawer(false);
        refreshCustomerRewards();
      }
    });
  };

  const handleUpdateAppointmentDateTime = (orderId, values) => {

    const newServiceDate = moment(
      values.date.format("L") + " " + values.time
    ).format("YYYY-MM-DDTHH:mm:ss[Z]");

    const callback = () => {
        // const serviceDate = moment(
        //   values.date.format("L") + " " + values.time
        // ).format("YYYY-MM-DDTHH:mm:ss[Z]");
      dispatch(updateAppointmentDateTime(orderId, newServiceDate)).then((res) => {
        if (res?.status === "success") {
          setShowUpdateAppointmentDate(false);
          // setShowEventDrawer(false);
        }
      });
    }

    // validate order  first with the new date and time, if there are any restrictions then show a confirmation modal, if user confirms then update the appointment date and time
    const valuesToUpdate = [
      {
        lineItems: [
          {
            productId: booking?.lineItems?.[0]?.productId,
            addOns:
              booking?.lineItems?.[0]?.addOns?.map((addon) => {
                return {
                  productType: 2,
                  ...addon
                };
              }) ?? [],
          },
        ],
        customerId: customer?.customerId,
        serviceDate: newServiceDate,
      },
    ];


    dispatch(
      validateRestriction(valuesToUpdate, facilityId, orderId)
    ).then((result) => {
      if (!result.mstatus) {
        Modal.confirm(updateOrderConfirmation(callback));
      } else {
        callback();
        // callCreateOrder();
      }
    });



  };

  return (
    <Row span={[16, 16]} style={style}>
      <Col span={24}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Title
            variant={5}
            style={{ margin: 0, fontSize: 20, color: "#161F3A" }}
          >
            Booking Information
          </Title>
          <Button
            type="text"
            style={{ margin: 0, padding: 0 }}
            onClick={() => setShowAuditLog(true)}
          >
            Audit Log
          </Button>
        </div>
      </Col>
      <Col span={24}>
        <Row>
          <Col flex="auto" style={{ marginTop: 8, marginBottom: 8 }}>
            <Text
              style={{
                fontWeight: 700,
              }}
            >
              {facilityServiceDate.format("h:mm A")} -{" "}
              {moment(facilityServiceDate)
                .add(orderDuration ?? 1, "hour")
                .format("h:mm A")}{" "}
              {facilityServiceDate.format("[(]DD MMM YYYY[)]")}
            </Text>
          </Col>
          <Col>
            <Button
              type="text"
              // TODO: isOrderCancelled chaipi remove
              disabled={disabled || isOrderCancelled}
              onClick={() => {
                setShowUpdateAppointmentDate(true);
              }}
              style={{ padding: 0 }}
            >
              Change
            </Button>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row
          span={[16, 16]}
          style={{
            paddingBottom: 12,
          }}
        >
          {lineItems?.map((lineItem, index) => {
            return (
              <BookingDetailRow
                formattedServicesWithBoostsStringWithDuration={booking?.formattedServicesWithBoostsStringWithDuration}
                rewards={rewards}
                key={lineItem?.lineItemId}
                orderId={orderId}
                lineItem={lineItem}
                lineItems={lineItems}
                index={index}
                setShowAddUpdateService={setShowAddUpdateService}
                deleteLineItem={deleteLineItem}
                refreshCustomerRewards={refreshCustomerRewards}
                isRewardsLoading={isRewardsLoading}
                disabled={disabled}
                customer={customer}
                facilityId={facilityId}
                manageRewardsDisabled={manageRewardsDisabled}
                chart={{
                  data: booking?.chart ?? {},
                  isLoading: isChartLoading
                }}
              />
            );
          })}
          <div className="d-flex align-center gap-8">
            <Button
              disabled={!staffId}
              // disabled={booking?.orderStatusString!=='Arrived'}
              type="text"
              style={{ padding: 0 }}
              onClick={() => {
                onClose?.();
                dispatch(push(`/dashboard/inventory/${booking?.orderId}`));
              }}
            >
              Inventory
            </Button>
            {isInventorySubmitted ? (
              <CheckCircleOutlined
                style={{
                  color: "#52c41a",
                }}
              />
            ) : (
              <CloseCircleOutlined
                style={{
                  color: "#f5222d",
                }}
              />
            )}
          </div>

          {instructions && (
            <Col span={24} style={{ marginTop: 10 }}>
              <Title
                style={{
                  fontSize: 16,
                  fontWeight: 700,
                  color: "#486BAF",
                  marginBottom: 4,
                }}
              >
                Address Instructions
              </Title>
              {instructions && <Text>{instructions}</Text>}
            </Col>
          )}

          {/* <Col span={24} style={{ marginTop: 6, marginBottom: 12 }}>
            <Button
              type="text"
              style={{ padding: 0 }}
              onClick={() => {
                setShowAddUpdateService(true);
              }}
            >
              Add Service
            </Button>
          </Col> */}
        </Row>
      </Col>
      <ChangeAppointmentModal
        // order={}
        booking={booking}
        visible={showUpdateAppointmentDate}
        onSave={handleUpdateAppointmentDateTime}
        onClose={() => {
          setShowUpdateAppointmentDate(false);
        }}
      />
      <ServiceAddonsModal
        visible={showAddUpdateService}
        onCancel={() => setShowAddUpdateService(false)}
        onSave={async (values) => {
          const valuesToUpdate = [
            {
              lineItems: [
                {
                  productId: values.productId,
                  addOns:
                    values.addOns?.map((addon) => {
                      return {
                        productId: addon,
                        productType: 2,
                      };
                    }) ?? [],
                },
              ],
              customerId: customer?.customerId,
              serviceDate: facilityServiceDate.format("YYYY-MM-DDTHH:mm:ss[Z]"),
            },
          ];

          const callback = async () => {
            if (isEditServiceModal) {
              await handleUpdateService(
                showAddUpdateService?.lineItemId,
                values
              );
            } else {
              await handleAddService(values);
            }
          };

          dispatch(
            validateRestriction(valuesToUpdate, facilityId, orderId)
          ).then((result) => {
            if (!result.mstatus) {
              Modal.confirm(updateOrderConfirmation(callback));
            } else {
              callback();
              // callCreateOrder();
            }
          });

          return;
        }}
        isEditModal={isEditServiceModal}
        customer={customer}
        facilityId={facilityId}
        operationTypeId={operationTypeId}
      />
      <AuditLogModal
        visible={showAuditLog}
        onClose={() => setShowAuditLog(false)}
        orderId={booking?.orderId}
        customerId={booking?.customerId}
        userId={customer?.userId}
        mode={Mode.Order}
      />
    </Row>
  );
}

const updateOrderConfirmation = (call) => ({
  title: "Update order",
  content: (
    <>
      This new service/addons/date have restrictions. Are you sure that you want to
      update this order?
    </>
  ),
  centered: true,
  maskClosable: true,
  onOk: (close) => {
    call();
    // callCreateOrder();
    close();
  },
  onCancel(close) {
    close();
  },
});
